import { Injectable } from '@angular/core';
import { environment } from '@dxc/environments';
import { FeatureFlag } from '@shared/types';

@Injectable({ providedIn: 'root' })
export class CustomerFeaturesService {
  hasFeature(feature: FeatureFlag): boolean {
    return environment.featureFlags?.includes(feature) ?? false;
  }
}
